const $ = jQuery;
document.addEventListener("DOMContentLoaded", (event) => {
	const blogLists = document.querySelectorAll(".blog-list");
	if (blogLists && blogLists.length > 0) {
		blogLists.forEach((blog) => {
			const posts = blog.querySelectorAll("article");
			posts.forEach((post) => {
				const div = document.createElement("div");
				div.className = "post-content-wrapper";
				if (!post.querySelector(".entry-featured-image-url")) return;
				post.querySelector(".entry-featured-image-url")?.after(div);

				if (post.querySelector(".entry-title")) div.appendChild(post.querySelector(".entry-title"));
				if (post.querySelector(".post-meta")) div.appendChild(post.querySelector(".post-meta"));
				if (post.querySelector(".post-content")) div.appendChild(post.querySelector(".post-content"));
			});
		});
	}

	const blogFeatureds = document.querySelectorAll(".blog-featured");
	if (blogFeatureds && blogFeatureds.length > 0) {
		blogFeatureds.forEach((blog) => {
			const posts = blog.querySelectorAll("article");
			posts.forEach((post) => {});
		});
	}
});
